export default "__VITE_ASSET__DBNMD6ae__"